import { render } from "./FieldVitalityCheckCerealIcon.vue?vue&type=template&id=40fe2b2a"
import script from "./FieldVitalityCheckCerealIcon.vue?vue&type=script&lang=js"
export * from "./FieldVitalityCheckCerealIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__